import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useQuery } from "@tanstack/react-query";
import DailyCheckIn from "./daily-tasks/DailyCheckIn/DailyCheckIn";
import HomeSurveyCard from "./daily-tasks/HomeSurveyCard";
import { useSurveyListOptions } from "@/pages/profile/surveys/surveys.api";
import "swiper/css";
import "swiper/css/pagination";

const SectionCheckIn = () => {
  // Tugallanmagan, ACTIVE survey'lar check-in kartasidan keyin slide bo'lib
  // chiqadi. Ko'rsatish/yashirish, tartib va rejani admin boshqaradi
  // (Survey.status / order / start_date / end_date — backend SurveyList'da
  // filtrlaydi). Bu yerda hech narsa hardcode qilinmaydi.
  const { data: surveys = [] } = useQuery(
    useSurveyListOptions({ showInHome: true })
  );
  const openSurveys = surveys.filter((s) => !s.is_completed);
  const hasSurveys = openSurveys.length > 0;

  return (
    <div className="px-4 container">
      <Swiper
        key={openSurveys.length}
        spaceBetween={8}
        slidesPerView={1}
        modules={[Pagination]}
        pagination={{
          enabled: hasSurveys,
          el: ".custom-pagination",
          clickable: true,
          bulletClass:
            "inline-block w-full rounded-full h-1 bg-white/20 transition-all duration-300",
          bulletActiveClass: "!bg-white",
        }}
      >
        <SwiperSlide>
          <DailyCheckIn />
        </SwiperSlide>
        {openSurveys.map((survey) => (
          <SwiperSlide key={survey.id}>
            <HomeSurveyCard survey={survey} />
          </SwiperSlide>
        ))}
      </Swiper>

      {hasSurveys && (
        <div className="flex items-center gap-1 max-w-[140px] mx-auto justify-center mt-1.5 custom-pagination"></div>
      )}
    </div>
  );
};

export default SectionCheckIn;
